import { styled } from '@mui/system'

export const ImageWrapper = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
})

export const Placeholder = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(200, 200, 200, 0.5)',
  backdropFilter: 'blur(10px)',
  transform: 'scale(1.1)',
  zIndex: 1,
  opacity: 1,
  transition: 'opacity 0.3s ease-in-out',
})

export const StyledImage = styled('img')({
  display: 'block',
  height: '100%',
  width: '100%',
  objectFit: 'contain',
  position: 'relative',
  zIndex: 2,
  opacity: 1,
  transition: 'opacity 0.3s ease-in-out',
})

export const FallbackImage = styled('img')({
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
  height: 'auto',
})
